/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuantityPool } from '../../models/quantity-pool';

export interface GetQuantityPool$Params {
  workCenterId: number;
}

export function getQuantityPool(http: HttpClient, rootUrl: string, params: GetQuantityPool$Params, context?: HttpContext): Observable<StrictHttpResponse<QuantityPool>> {
  const rb = new RequestBuilder(rootUrl, getQuantityPool.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuantityPool>;
    })
  );
}

getQuantityPool.PATH = '/api/v1/WorkCenter/{workCenterId}/QuantityPool';
